/* eslint-disable */
import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useEffect,
} from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  useImperativeHandle(ref, () => ({
    setModelAdd: () => {
      setEditRecord(null);
      form.resetFields();
      form.setFieldsValue({
        name: "",
      });
      setVisible(true);
    },
    setModelEdit: (record) => {
      setEditRecord(record);
      form.setFieldsValue({
        name: record.name,
        status: record.status,
      });
      setVisible(true);
    },
  }));

  const onFinish = async (values) => {
    setLoading(true);
    try {
      let response;
      if (editRecord) {
        // 编辑模式 - 使用 getGlAcctSubTypeUpdate
        response = await http.post(api.getGlAcctSubTypeUpdate, {
          id: editRecord.id,
          name: values.name,
          status: values.status || 0,
        });
      } else {
        // 新增模式 - 使用 getGlAcctSubTypeAdd
        response = await http.post(api.getGlAcctSubTypeAdd, {
          name: values.name,
        });
      }

      if (response?.code === "1") {
        message.success(
          editRecord ? "Updated Successfully" : "Added Successfully",
        );
        setVisible(false);
        form.resetFields();
        setEditRecord(null);
        onSuccess && onSuccess();
      } else {
        message.error(
          response?.msg || (editRecord ? "Update failed" : "Add failed"),
        );
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            {editRecord
              ? "EDIT GL ACCOUNT SUB TYPE"
              : "ADD GL ACCOUNT SUB TYPE"}
          </Typography.Title>
        </Flex>
      }
      width="30%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
        setEditRecord(null);
      }}
      style={{ minHeight: "300px" }}
      maskClosable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            key="back"
            onClick={() => {
              setVisible(false);
              form.resetFields();
              setEditRecord(null);
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>
      }
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              form={form}
              name="createGLAccountSubTypeForm"
              layout="horizontal"
              labelCol={{ style: { width: "150px" } }}
              wrapperCol={{ style: { flex: 1 } }}
              onFinish={onFinish}
            >
              <Flex justify="space-between" align="flex-start">
                <div style={{ flex: 1 }}>
                  <Form.Item
                    name="name"
                    label="Name"
                    rules={[{ required: true, message: "Please enter Name" }]}
                  >
                    <Input placeholder="Please enter Name" allowClear />
                  </Form.Item>

                  {editRecord && (
                    <Form.Item
                      name="status"
                      label="Status"
                      rules={[
                        { required: true, message: "Please select Status" },
                      ]}
                    >
                      <Select
                        placeholder="Select Status"
                        options={[
                          { label: "Active", value: 1 },
                          { label: "Inactive", value: 0 },
                        ]}
                        allowClear
                      />
                    </Form.Item>
                  )}
                </div>
              </Flex>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default AddModal;
